export default {
    'it-IT': {
        noQuestions:
            'Non sono state fatte ancora domande sul prodotto. Fai tu la prima domanda!',
        makeAQuestion: 'Fai una domanda',
        questionInfo:
            'Chiediamo gentilmente di non abusare di questa possibilità e leggere prima le domande già presenti. Se non si trova nulla di soddisfacente è possibile inviare la propria domanda.',
        readTheGuideLines:
            'Leggi le <a class="prd-link" href={guidelinesLink} target="_blank">linee guida</a>',
        allQuestions: 'Tutte le domande',
        noAnswers: 'Nessuna risposta',
        oneAnswer: '1 risposta',
        answers: '{x} risposte',
        reportQuestionAbuse: 'Segnala la domanda',
        reportAnswerAbuse: 'Segnala la risposta',
        questionAbuseKind: 'Per quale motivo vuoi segnalare questa domanda?',
        answerAabuseKind: 'Per quale motivo vuoi segnalare questa risposta?',
        questionsTitle: 'Domande per {title}',
        mustBeLoggedIn:
            'Per fare una domanda agli altri utenti è necessario essere loggati',
        clickToLogIn: 'Clicca qui per loggarti.',
        goToProduct: 'Vai al prodotto',
        sortBy: 'Ordina per:',
        sortByMostAnswers: 'Più risposte',
        sortByMostAnswersTitle: 'Ordina i prodotti per quelli con più risposte',
        sortByMostRecent: 'Più recente',
        sortByMostRecentTitle: 'Ordina i prodotti per i più recenti',
        answerQuestionLink: 'Rispondi',
        askAQuestionForProduct:
            'Fai la domanda per <a class="link" href={slug}>{title}</a>',
        sendQuestion: 'Invia la domanda',
        viewAllQuestions: 'Leggi tutte le domande e risposte',
        answerQuestionForProduct:
            'Rispondi alla domanda per <a class="link" href={slug}>{title}</a>',
        questionFromUser: "La domanda dell'utente {nickname}",
        sendAnswer: 'Invia la risposta',
    },
    'fr-FR': {
        noQuestions:
            "Aucune question n'a été posée concernant ce produit. Soyez le premier à le faire!",
        makeAQuestion: 'Poser une question',
        questionInfo:
            "Si aucune de ces réponses ne vous satisfait, envoyez votre question. Cependant, nous vous demandons de bien lire les réponses données avant de poser votre question afin d'éviter les doublons.",
        readTheGuideLines:
            'Lire les <a class="prd-link" href={guidelinesLink} target="_blank">directives</a>.',
        allQuestions: 'Tutte le domande',
        noAnswers: 'Aucune réponse',
        oneAnswer: '1 réponse',
        answers: '{x} risposte',
        reportQuestionAbuse: 'Signaler la question',
        reportAnswerAbuse: 'Signaler la réponse',
        questionAbuseKind:
            'Pour quelle raison souhaitez-vous signaler cette question?',
        answerAabuseKind:
            'Pour quelle raison souhaitez-vous signaler cette réponse?',
        questionsTitle: 'Questions pour {title}',
        mustBeLoggedIn:
            'Pour poser une question aux autres utilisateurs vous devez être connecté(e).',
        clickToLogIn: 'Cliquer ici pour vous connecter.',
        goToProduct: 'Aller au produit',
        sortBy: 'Trier par:',
        sortByMostAnswers: 'Plus de réponses',
        sortByMostAnswersTitle:
            'Trier les produits par nombre de réponses données',
        sortByMostRecent: 'Plus récents',
        sortByMostRecentTitle: 'Trier les produits les plus récents',
        answerQuestionLink: 'Répondre',
        askAQuestionForProduct:
            'Poser une question pour <a class="link" href={slug}>{title}</a>',
        sendQuestion: 'Envoyer ma question',
        viewAllQuestions: 'Voir toutes les questions et réponses',
        answerQuestionForProduct:
            'Répondre à la question pour <a class="link" href={slug}>{title}</a>',
        questionFromUser: "Question de l'utilisateur {nickname}",
        sendAnswer: 'Envoyer ma réponse',
    },
    'es-ES': {
        noQuestions:
            'No se han realizado preguntas de este producto. ¡Sé el primero en preguntar!',
        makeAQuestion: 'Haz una pregunta',
        questionInfo:
            'Si no encuentra nada que le deje satisfecho, puede hacer su propia pregunta. Le pedimos que lea las respuestas presentes antes de preguntar para no saturar esta posibilidad.',
        readTheGuideLines:
            'Leer las <a class="prd-link" href={guidelinesLink} target="_blank">directrices</a>',
        allQuestions: 'Leer todas las preguntas',
        noAnswers: 'Ninguna respuesta',
        oneAnswer: '1 respuesta',
        answers: '{x} respuestas',
        reportQuestionAbuse: 'Denunciar la pregunta',
        reportAnswerAbuse: 'Denunciar la respuesta',
        questionAbuseKind: '¿Por qué quieres denunciar esta pregunta?',
        answerAabuseKind: '¿Por qué quieres denunciar esta respuesta?',
        questionsTitle: 'Preguntas para {title}',
        mustBeLoggedIn:
            'Para hacer una pregunta al resto de usuarios es necesario estar registrado.',
        clickToLogIn: 'Haz clic aquí para iniciar sesión.',
        goToProduct: 'Ir al producto',
        sortBy: 'Ordenar por:',
        sortByMostAnswers: 'Más respuestas',
        sortByMostAnswersTitle:
            'Ordena los productos por aquellos con más respuestas',
        sortByMostRecent: 'Más recientes',
        sortByMostRecentTitle: 'Ordena por productos más recientes',
        answerQuestionLink: 'Responder',
        askAQuestionForProduct:
            'Hacer pregunta para <a class="link" href={slug}>{title}</a>',
        sendQuestion: 'Enviar pregunta',
        viewAllQuestions: 'Leer todas las preguntas y respuestas',
        answerQuestionForProduct:
            'Responder a la pregunta para <a class="link" href={slug}>{title}</a>',
        questionFromUser: 'Pregunta del usuario {nickname}',
        sendAnswer: 'Enviar respuesta',
    },
    'en-GB': {
        noQuestions:
            'No questions have been raised yet about this product. Be the first!',
        makeAQuestion: 'Ask a question',
        questionInfo:
            'If you do not find anything useful, ask us a question, we kindly ask that you do not abuse this possibility.',
        readTheGuideLines:
            'Read the <a class="prd-link" href={guidelinesLink} target="_blank">guidelines</a>',
        allQuestions: 'Read all the questions',
        noAnswers: 'No answers',
        oneAnswer: '1 answer',
        answers: '{x} answers',
        reportQuestionAbuse: 'Report the question',
        reportAnswerAbuse: 'Report the answer',
        questionAbuseKind: 'Why do you want to report this question?',
        answerAabuseKind: 'Why do you want to report this answer?',
        questionsTitle: 'Questions for {title}',
        mustBeLoggedIn:
            'To ask a question to other users you need to be logged in.',
        clickToLogIn: 'Click here to login.',
        goToProduct: 'Go to product',
        sortBy: 'Sort by:',
        sortByMostAnswers: 'Most answers',
        sortByMostAnswersTitle: 'Sort by articles with most answers',
        sortByMostRecent: 'Most recent',
        sortByMostRecentTitle: 'Sort by most recent articles',
        answerQuestionLink: 'Answer',
        askAQuestionForProduct:
            'Ask a question for <a class="link" href={slug}>{title}</a>',
        sendQuestion: 'Send the question',
        viewAllQuestions: 'View all questions and answers',
        answerQuestionForProduct:
            'Answer the question for <a class="link" href={slug}>{title}</a>',
        questionFromUser: 'Question from user {nickname}',
        sendAnswer: 'Send answer',
    },
    'en-US': {
        noQuestions:
            'No questions have been raised yet about this product. Be the first!',
        makeAQuestion: 'Ask a question',
        questionInfo:
            'If you do not find anything useful, ask us a question, we kindly ask that you do not abuse this possibility.',
        readTheGuideLines:
            'Read the <a class="prd-link" href={guidelinesLink} target="_blank">guidelines</a>',
        allQuestions: 'Read all the questions',
        noAnswers: 'No answers',
        oneAnswer: '1 answer',
        answers: '{x} answers',
        reportQuestionAbuse: 'Report the question',
        reportAnswerAbuse: 'Report the answer',
        questionAbuseKind: 'Why do you want to report this question?',
        answerAabuseKind: 'Why do you want to report this answer?',
        questionsTitle: 'Questions for {title}',
        mustBeLoggedIn:
            'To ask a question to other users you need to be logged in.',
        clickToLogIn: 'Click here to login.',
        goToProduct: 'Go to product',
        sortBy: 'Sort by:',
        sortByMostAnswers: 'Most answers',
        sortByMostAnswersTitle: 'Sort by articles with most answers',
        sortByMostRecent: 'Most recent',
        sortByMostRecentTitle: 'Sort by most recent articles',
        answerQuestionLink: 'Answer',
        askAQuestionForProduct:
            'Ask a question for <a class="link" href={slug}>{title}</a>',
        sendQuestion: 'Send the question',
        viewAllQuestions: 'View all questions and answers',
        answerQuestionForProduct:
            'Answer the question for <a class="link" href={slug}>{title}</a>',
        questionFromUser: 'Question from user {nickname}',
        sendAnswer: 'Send answer',
    },
    'de-DE': {
        noQuestions:
            'Es existieren noch keine Fragen zum Produkt. Stellen Sie die erste!',
        makeAQuestion: 'Frage stellen',
        questionInfo:
            'Wir weisen freundlich darauf hin, zuerst die bereits formulierten Fragen zu lesen. Sollten Sie keine passende Frage zu Ihrem Anliegen finden, stellen Sie bitte Ihre eigene.',
        readTheGuideLines:
            'Lesen Sie die <a class="prd-link" href={guidelinesLink} target="_blank">Richtlinien</a>',
        allQuestions: 'Alle Fragen lesen',
        noAnswers: 'Keine Antworten',
        oneAnswer: '1 Antwort',
        answers: '{x} Antworten',
        reportQuestionAbuse: 'Melden Sie die Frage',
        reportAnswerAbuse: 'Melden Sie die Antwort',
        questionAbuseKind: 'Warum möchten Sie diese Frage melden?',
        answerAabuseKind: 'Warum möchten Sie diese Antwort melden?',
        questionsTitle: 'Fragen für {title}',
        mustBeLoggedIn:
            'Um anderen Usern eine Frage zu stellen, müssen Sie eingeloggt sein.',
        clickToLogIn: 'Klicken Sie hier, um sich anzumelden.',
        goToProduct: 'Zum Produkt',
        sortBy: 'Filtern nach:',
        sortByMostAnswers: 'Mehr Antworte',
        sortByMostAnswersTitle:
            'Produkte nach höhster Anzahl an Antworten filtern',
        sortByMostRecent: 'Jüngsterer Artikel',
        sortByMostRecentTitle: 'Artikel nach den jüngsteren filtern',
        answerQuestionLink: 'Antworten',
        askAQuestionForProduct:
            'Frage für <a class="link" href={slug}>{title}</a> stellen',
        sendQuestion: 'Frage absenden',
        viewAllQuestions: 'Alle Fragen und Antworten lesen',
        answerQuestionForProduct:
            'Frage für <a class="link" href={slug}>{title}</a> beantworten',
        questionFromUser: 'Userfrage {nickname}',
        sendAnswer: 'Antwort absenden',
    },
    'en-AU': {
        noQuestions:
            'No questions have been raised yet about this product. Be the first!',
        makeAQuestion: 'Ask a question',
        questionInfo:
            'If you do not find anything useful, ask us a question, we kindly ask that you do not abuse this possibility.',
        readTheGuideLines:
            'Read the <a class="prd-link" href={guidelinesLink} target="_blank">guidelines</a>',
        allQuestions: 'Read all the questions',
        noAnswers: 'No answers',
        oneAnswer: '1 answer',
        answers: '{x} answers',
        reportQuestionAbuse: 'Report the question',
        reportAnswerAbuse: 'Report the answer',
        questionAbuseKind: 'Why do you want to report this question?',
        answerAabuseKind: 'Why do you want to report this answer?',
        questionsTitle: 'Questions for {title}',
        mustBeLoggedIn:
            'To ask a question to other users you need to be logged in.',
        clickToLogIn: 'Click here to login.',
        goToProduct: 'Go to product',
        sortBy: 'Sort by:',
        sortByMostAnswers: 'Most answers',
        sortByMostAnswersTitle: 'Sort by articles with most answers',
        sortByMostRecent: 'Most recent',
        sortByMostRecentTitle: 'Sort by most recent articles',
        answerQuestionLink: 'Answer',
        askAQuestionForProduct:
            'Ask a question for <a class="link" href={slug}>{title}</a>',
        sendQuestion: 'Send the question',
        viewAllQuestions: 'View all questions and answers',
        answerQuestionForProduct:
            'Answer the question for <a class="link" href={slug}>{title}</a>',
        questionFromUser: 'Question from user {nickname}',
        sendAnswer: 'Send answer',
    },
};
